import type { CloserLeadFormData } from '@/types'

const STORAGE_PREFIX = 'crm:closer-lead-draft'

export const emptyCloserLeadFormData: CloserLeadFormData = {
  empresa: '',
  contato: '',
  cargo: '',
  telefone: '',
  email: '',
  site: '',
  segmento: '',
  plataforma: '',
  modelo: 'B2C',
  faturamento: '',
  trafego: '',
  origem: '',
  problema: '',
  observacoes: '',
  servicos: [],
  score: 50,
}

function draftKey(userId: string): string {
  return `${STORAGE_PREFIX}:${userId}`
}

export function hasCloserLeadDraftContent(data: CloserLeadFormData): boolean {
  const normalized: CloserLeadFormData = {
    ...emptyCloserLeadFormData,
    ...data,
    servicos: data.servicos || [],
  }

  const keys: (keyof CloserLeadFormData)[] = [
    'empresa',
    'contato',
    'cargo',
    'telefone',
    'email',
    'site',
    'segmento',
    'plataforma',
    'modelo',
    'faturamento',
    'trafego',
    'origem',
    'problema',
    'observacoes',
    'score',
    'servicos',
    'empresaId',
    'parceiroId',
  ]

  for (const key of keys) {
    const current = normalized[key]
    const empty = emptyCloserLeadFormData[key]

    if (key === 'servicos') {
      const currentList = current as string[]
      const emptyList = empty as string[]
      if (currentList.length !== emptyList.length) return true
      if (currentList.some((item, index) => item !== emptyList[index])) return true
      continue
    }

    if (current !== empty) return true
  }

  return false
}

export function loadCloserLeadDraft(userId: string): CloserLeadFormData | null {
  if (!userId || typeof window === 'undefined') return null
  try {
    const raw = localStorage.getItem(draftKey(userId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as CloserLeadFormData
    return { ...emptyCloserLeadFormData, ...parsed, servicos: parsed.servicos || [] }
  } catch {
    return null
  }
}

export function saveCloserLeadDraft(userId: string, data: CloserLeadFormData): void {
  if (!userId || typeof window === 'undefined') return
  if (!hasCloserLeadDraftContent(data)) {
    clearCloserLeadDraft(userId)
    return
  }
  try {
    localStorage.setItem(draftKey(userId), JSON.stringify(data))
  } catch {
    // quota exceeded — ignore silently
  }
}

export function clearCloserLeadDraft(userId: string): void {
  if (!userId || typeof window === 'undefined') return
  localStorage.removeItem(draftKey(userId))
}
